function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.53 1.47A4.995 4.995 0 000 5a4.995 4.995 0 009.831 1.25h-1.3a3.746 3.746 0 01-3.534 2.5A3.754 3.754 0 011.245 5a3.754 3.754 0 013.752-3.75 3.7 3.7 0 012.639 1.112L5.622 4.376H10V0L8.53 1.469z"
});

function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10"
  }, props), _ref);
}

export default SvgRefresh;